import React from 'react';

import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

interface YellowWarningProps {
  message: string;
  className?: string;
}

const YellowWarning: React.FC<YellowWarningProps> = ({ message, className }) => {
  if (!message) {
    return null;
  }

  return (
    <Stack
      alignItems="center"
      className={cn(
        'mt-16 mb-20 w-full rounded-8 bg-[#eec96baf] border border-[#F1C864] px-12 py-10',
        className,
      )}
      direction="row"
      gapX={12}>
      <Typography className="text-[#C56A11]" numberOfLines={3} variant="body-short-02">
        {message}
      </Typography>
    </Stack>
  );
};

export default YellowWarning;
